import React from "react";
import {Typography, withStyles} from "@material-ui/core";
import styles from "./styles";

const RouteNotFound = ({classes}) => (
    <div className={classes.root}>
        <Typography className={classes.error}>Error 404</Typography>
        <Typography className={classes.text}>It seems that this page doesn't exist (yet).</Typography>
        <Typography className={classes.text}>Please return to the previous page or to the <a href={"/"}>home page</a></Typography>
    </div>
);

export default withStyles(styles)(RouteNotFound)